import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import {store} from './store/store';
import { IntlProvider } from 'react-intl';
import enMessages from './lang/en.json';
import ErrorFallback from './errorboundary';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorFallback>
      <IntlProvider locale={'en'} messages={enMessages}>
        <Provider store={store}>
          <App />
        </Provider>
      </IntlProvider>
    </ErrorFallback>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
